import React from "react";
import "../Pages.scss";
import Hero from "../../Section/Hero/Hero";
import Promo from "../../Section/Promo/Promo";
import About from "../../Section/About/About";
import Product from "../../Section/Product/Product";
import ScrollToAnchor from "../ScrollToAnchor";
import Location from "../../Section/Lokasi/Location-pages";
import PromoNew from "../../Section/Promo/PromoNew";
import Consultant from "../../Section/Consultant/Consultant";
const Home = () => {
  return (
    <div className="content-page">
      <ScrollToAnchor />
      <Hero />
      <About />
      <PromoNew />
      <Promo />
      <Product />
      <Location />
      <Consultant />
    </div>
  );
};

export default Home;
